import { Box } from "@mui/material";
import { markdownToHtml } from "@ssf/components";
import { useEffect, useState } from "react";

export const Markdown = ({ children }: { children: string }) => {
  const [html, setHtml] = useState("");

  useEffect(() => {
    markdownToHtml(children).then(({ value }) => {
      if (typeof value === "string") {
        setHtml(value);
      }
    });
  }, [children]);

  return (
    <Box
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        h1: { fontSize: 20 },
        table: { width: "100%" },
        th: { textAlign: "left" },
      }}
    />
  );
};
